/*
 * Copyright (C) 2021 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export { UtilAttachAlign as DDialogAlign } from "./util/util-attach";
